import { TextField } from '@material-ui/core';
import React, { FunctionComponent } from 'react';

import Texto from '@infotrack/presentacion-componentes/texto';

import IDocumentoFiltro from 'Infotrack@Modelos/negocioRefactor/entidades/consulta/documento/IDocumentoFiltro';

interface ICampoProveedorProps {
    manejarCambioFiltro: (
        nombreFiltro: keyof IDocumentoFiltro,
        nuevoValor: IDocumentoFiltro[keyof IDocumentoFiltro]
    ) => any;
    valor: string;
}

const CampoProveedor: FunctionComponent<ICampoProveedorProps> = ({ manejarCambioFiltro, valor }) => (
    <TextField
        fullWidth
        label={<Texto id="Documentos.CampoProveedor.Nombre" />}
        onChange={(event) => manejarCambioFiltro('Proveedor', event.target.value)}
        value={valor}
        id={`CampoProveedor-${valor}`}
    />
);

export default CampoProveedor;
